import type { LucideIcon } from "lucide-react";
import {
  Award,
  Ban,
  BriefcaseBusiness,
  Building2,
  Calendar,
  Cpu,
  DollarSign,
  Globe,
  Hash,
  Mail,
  MapPin,
  Radar,
  Search,
  Tag,
  UserRound,
  Users,
} from "lucide-react";

export type FilterSectionId =
  | "personas"
  | "jobTitles"
  | "seniority"
  | "location"
  | "keywords"
  | "company"
  | "emailStatus"
  | "source"
  | "employees"
  | "industry"
  | "orgIds"
  | "revenue"
  | "technologies"
  | "hiring"
  | "orgDomains"
  | "excludeTech";

export type FilterSection = {
  id: FilterSectionId;
  label: string;
  defaultOpen: boolean;
  advanced?: boolean;
  /** Only shown on Leads (workspace) scope */
  workspaceOnly?: boolean;
  icon: LucideIcon;
};

/** Canonical Apollo People API Search filter sections for the rail. */
export const FILTER_SECTIONS: FilterSection[] = [
  { id: "personas", label: "Personas", defaultOpen: true, icon: UserRound },
  {
    id: "jobTitles",
    label: "Job titles",
    defaultOpen: true,
    icon: BriefcaseBusiness,
  },
  { id: "seniority", label: "Seniority", defaultOpen: false, icon: Award },
  { id: "location", label: "Person location", defaultOpen: true, icon: MapPin },
  { id: "company", label: "Company", defaultOpen: false, icon: Building2 },
  {
    id: "emailStatus",
    label: "Email status",
    defaultOpen: false,
    icon: Mail,
  },
  { id: "keywords", label: "Keywords", defaultOpen: false, icon: Search },
  {
    id: "source",
    label: "Source / created",
    defaultOpen: true,
    workspaceOnly: true,
    icon: Calendar,
  },
  {
    id: "employees",
    label: "# Employees",
    defaultOpen: false,
    advanced: true,
    icon: Users,
  },
  {
    id: "industry",
    label: "Industry",
    defaultOpen: false,
    advanced: true,
    icon: Tag,
  },
  {
    id: "orgIds",
    label: "Company / org IDs",
    defaultOpen: false,
    advanced: true,
    icon: Hash,
  },
  {
    id: "revenue",
    label: "Revenue",
    defaultOpen: false,
    advanced: true,
    icon: DollarSign,
  },
  {
    id: "technologies",
    label: "Technologies",
    defaultOpen: false,
    advanced: true,
    icon: Cpu,
  },
  {
    id: "hiring",
    label: "Hiring / intent signals",
    defaultOpen: false,
    advanced: true,
    icon: Radar,
  },
  {
    id: "orgDomains",
    label: "Company HQ & domains",
    defaultOpen: false,
    advanced: true,
    icon: Globe,
  },
  {
    id: "excludeTech",
    label: "Exclude technologies",
    defaultOpen: false,
    advanced: true,
    icon: Ban,
  },
];

export function defaultOpenMap(): Record<FilterSectionId, boolean> {
  return Object.fromEntries(
    FILTER_SECTIONS.map((s) => [s.id, s.defaultOpen]),
  ) as Record<FilterSectionId, boolean>;
}

export {
  encodeFiltersParam,
  decodeFiltersParam,
} from "@/lib/filter-url";
